import classNames from "classnames";
import {EmblaIcon} from "../../emblaIcon/emblaIcon";
import {EmblaIcons} from "../../../emblaIcons";
import React from "react";
import './TableCells.scss';

type TableGodkendtCellProps = {
    godkendt?: boolean;
}
export const TableGodkendtCell = ({godkendt}: TableGodkendtCellProps) => {
    return (
        <div className={classNames("flex-container")
        }>
            {godkendt ?
                <EmblaIcon
                    additionalClasses={"success square"}
                    iconName={EmblaIcons.Success}
                    iconColor={"success"}
                />
                :
                <EmblaIcon
                    additionalClasses={"warning square"}
                    iconName={EmblaIcons.Close}
                    iconColor={"danger"}
                />
            }
        </div>
    )
        ;
};
